import React from 'react';

import { graphql, useFragment } from 'react-relay';

import { type ProductKeys } from '../../../../common/constants/products';
import type { ThirdPartyConfigsBootstrap } from '../../../../common/constants/schemas/3p-config';
import type { SearchResultProps } from '../../../../common/types';
import { ErrorBoundary } from '../../../../controllers/error-boundary';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { OAUTH_BANNER_POSITION } from '../search-result';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { BulkConnectBanner } from '../search-result/bulk-connect-banner';

import type { searchResultCql_AtlassianSearchPage$key } from './__generated__/searchResultCql_AtlassianSearchPage.graphql';
import { ConfluenceSearchResponse } from './confluence-search-response';

export type SearchResultCQLProps = SearchResultProps<searchResultCql_AtlassianSearchPage$key> & {
	thirdPartyConfigs: ThirdPartyConfigsBootstrap;
	availableProducts: ProductKeys[];
};

export const SearchResultCQL = ({
	node,
	position,
	cloudId,
	thirdPartyConfigs,
	availableProducts,
	selectedProduct,
	searchQuery,
	searchSessionId,
	primaryProduct,
	appMode,
	mainContentWidth,
}: SearchResultCQLProps): React.JSX.Element => {
	const data = useFragment(
		graphql`
			fragment searchResultCql_AtlassianSearchPage on ConfluenceSearchResponse {
				...confluenceSearchResponse_AtlassianSearchPage
			}
		`,
		node,
	);

	return (
		<>
			{position === OAUTH_BANNER_POSITION && (
				<BulkConnectBanner
					availableProducts={availableProducts}
					cloudId={cloudId}
					selectedProduct={selectedProduct}
					thirdPartyConfigs={thirdPartyConfigs}
				/>
			)}
			<ErrorBoundary section="SearchPageResultRecordCQL">
				<ConfluenceSearchResponse
					appMode={appMode}
					cloudId={cloudId}
					mainContentWidth={mainContentWidth}
					node={data}
					position={position}
					primaryProduct={primaryProduct}
					searchQuery={searchQuery}
					searchSessionId={searchSessionId}
					selectedProduct={selectedProduct}
				/>
			</ErrorBoundary>
		</>
	);
};
